module.exports = __webpack_public_path__ + "img/table.296411a1.png";